import React from 'react';
import { array, object } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {orderBy, isEmpty} from 'lodash';

import TabPanel, { Tab, TabContent } from '../../components/TabPanel';
import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import ContactsTable from './ContactsTable';
import ConfirmButton from '../../components/ConfirmButton';
import LinksTableAndSearch from './LinksTableAndSearch';
import { bob } from '../../data/tabs';

import {isAllowed} from '../../helpers/auth';
import {Permissions} from '../../helpers/permissions';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './ClientDataInsert.module.css';

const ClientDataInsert = ({
    activeNavCompany,
    contacts,
    contactLinks,
    fetchContacts,
    fetchContactLinks,
    fetchErpLinks,
    history,
    links,
    selectedNode,
    toggleContactsLoading,
    ...props
}) => {

    const getContactLinks = async () => {
        await fetchContacts(selectedNode.id);

        if (contacts) {
            const idList = contacts.map(contact => contact.id);
            await fetchContactLinks(idList);
        } else {

            await fetchContactLinks([]);
        }
    };

    const handleSort = (props, property) => {
        return (event) => {
            props.reorderItems(property);
        };
    };

    const handleContactFilter = searchTerm => {
        const {fetchContacts} = props;

        if (isEmpty(searchTerm)) {
            fetchContacts(selectedNode.id);

            return;
        }

        fetchContacts(selectedNode.id, {searchFilter: searchTerm});
    };

    const handleNavigateToContacts = () => {
        history.push({
            pathname: `/v2/dashboard/client`,
            search:   `appId=${bob.key}&childId=517558d4-c3f4-417d-a2d2-c10ec2f6cf2f&client=${selectedNode.id}&company=${activeNavCompany.id}&parentId=a73c8c70-35aa-48b7-a797-4c607ae25280`
        });
    };

    const featureFlagForLinksTabs = () => {
        if (process.env.erpAgentEnabled) {
            if (process.env.contactsEnabled) {
                return (
                    <TabPanel
                        aria-label="Client Data Options"
                        classes={{
                            root: classes.tabPanel
                        }}
                    >
                        <Tab title="Contacts">
                            <TabContent
                                classes={{
                                    root: classes.areaTabContent
                                }}
                            >
                                <div className={classes.contactsContainer}>
                                    <span>Contacts have been relocated. Click below to navigate.</span>
                                    <div className={classes.buttonContainer}>
                                        <ConfirmButton
                                            confirm={handleNavigateToContacts}
                                            label="Navigate"
                                            type="button"
                                        />
                                    </div>
                                </div>
                            </TabContent>
                        </Tab>
                    </TabPanel>
                );
            } else {
                return (
                    <TabPanel
                        aria-label="Client Data Options"
                        classes={{
                            root: classes.tabPanel
                        }}
                    >
                        <Tab title="Contacts">
                            <TabContent
                                classes={{
                                    root: classes.areaTabsContent
                                }}
                            >
                                <ActionBar
                                    onSearch={handleContactFilter}
                                >
                                    <ActionBarItem
                                        onClick={() => props.onToggleCreateContactModal(true)}
                                        hidden={!isAllowed(props.currentScopes, Permissions('architectFull'))}
                                        type="add"
                                    >
                                        New Contact
                                    </ActionBarItem>
                                </ActionBar>
                                <div className={classes.scrollContainer}>
                                    <ContactsTable
                                        companyInfo={props.companyInfo}
                                        contacts={contacts}
                                        isFullArchitectAllowed={props.isFullArchitectAllowed}
                                        onToggleDeleteContactModal={props.onToggleDeleteContactModal}
                                        onToggleDeleteLinkModal={props.onToggleDeleteLinkModal}
                                        onToggleEditContactModal={props.onToggleEditContactModal}
                                        order={props.order}
                                        orderBy={orderBy}
                                        onSort={property => handleSort(props, property)}
                                    />
                                </div>
                            </TabContent>
                        </Tab>
                        <Tab title="Client Links">
                            <LinksTableAndSearch
                                order={props.order}
                                orderBy={props.orderBy}
                                handleSort={handleSort}
                                onToggleCreateLinkModal={props.onToggleCreateLinkModal}
                                onToggleDeleteLinkModal={props.onToggleDeleteLinkModal}
                                selectedNode={selectedNode}
                                links={links}
                            />
                        </Tab>
                        <Tab title="Contact Links">
                            <LinksTableAndSearch
                                order={props.order}
                                orderBy={props.orderBy}
                                handleSort={handleSort}
                                onToggleCreateLinkModal={props.onToggleCreateContactLinkModal}
                                onToggleDeleteLinkModal={props.onToggleDeleteLinkModal}
                                selectedNode={selectedNode}
                                links={contactLinks}
                                getLinks={getContactLinks}
                                linkType={'contact'}
                            />
                        </Tab>
                    </TabPanel>
                );
            }
        } else {
            return (
                <TabPanel
                    aria-label="Client Data Options"
                    classes={{
                        root: classes.tabPanel
                    }}
                >
                    <Tab title="Contacts">
                        <TabContent
                            classes={{
                                root: classes.areaTabContent
                            }}
                        >
                            <ActionBar
                                onSearch={handleContactFilter}
                            >
                                <ActionBarItem
                                    onClick={() => props.onToggleCreateContactModal(true)}
                                    hidden={!isAllowed(props.currentScopes, Permissions('architectFull'))}
                                    type="add"
                                >
                                    New Contact
                                </ActionBarItem>
                            </ActionBar>
                            <div className={classes.scrollContainer}>
                                <ContactsTable
                                    companyInfo={props.companyInfo}
                                    contacts={contacts}
                                    isFullArchitectAllowed={props.isFullArchitectAllowed}
                                    onToggleDeleteContactModal={props.onToggleDeleteContactModal}
                                    onToggleDeleteLinkModal={props.onToggleDeleteLinkModal}
                                    onToggleEditContactModal={props.onToggleEditContactModal}
                                    order={props.order}
                                    orderBy={orderBy}
                                    onSort={property => handleSort(props, property)}
                                />
                            </div>
                        </TabContent>
                    </Tab>
                </TabPanel>
            );
        }
    };

    return (
        <div className={classes.root}>
            {featureFlagForLinksTabs()}
        </div>
    );
};

ClientDataInsert.defaultProps = {
    companyInfo: {},
    contacts:    [],
    links:       []
};

ClientDataInsert.propTypes = {
    companyInfo: object,
    contacts:    array,
    links:       array
};

const mapStateToProps = state => {
    const {
        areas,
        order,
        links,
        contactLinks,
        contacts,
        orderBy: orderByKey
    } = state.architect;

    return {
        activeNavCompany: state.bob.activeNavCompany,
        areas:            orderBy(areas, [orderByKey], order),
        order,
        orderBy:          orderByKey,
        currentScopes:    state.core.currentScopes,
        contacts:         orderBy(contacts, [orderByKey], order),
        companyInfo:      state.companyInfo,
        links:            orderBy(links, [orderByKey], order),
        contactLinks:     orderBy(contactLinks, [orderBy], order)
    };
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientDataInsert));
